
const isHoliday = (date, startDate, publicHolidays, nonPublicHolidays) => {
    let daysInNumber = date.getDay();

    if (startDate && date <= startDate) {
        return true;
    }

    if (daysInNumber == 0 || daysInNumber == 6) {
        return true;
    } else {
        if ((publicHolidays && publicHolidays.length > 0) || (nonPublicHolidays && nonPublicHolidays.length > 0)) {
            const currentDate = ('0' + date).slice(-2) + '/' + ('0' + (date.getMonth() + 1)).slice(-2) + '/' + date.getYear(); // 'DD/MM/YYYY'
            const currentMonthDay = date.getDate() + '-' + (date.getMonth() + 1); // 'DD-MM'
            return (publicHolidays.includes(currentMonthDay) || nonPublicHolidays.includes(currentDate));
        } else {
            return false;
        }
    }
}

export default isHoliday;
